export const GET_NOTIFICATIONS_REQUEST = 'NOTIFICATIONS.GET_NOTIFICATIONS_REQUEST';
export const GET_NOTIFICATIONS_SUCCESS = 'NOTIFICATIONS.GET_NOTIFICATIONS_SUCCESS';
export const GET_NOTIFICATIONS_ERROR = 'NOTIFICATIONS.GET_NOTIFICATIONS_ERROR';
export const GET_NOTIFICATIONS_HEADER_REQUEST = 'NOTIFICATIONS.GET_NOTIFICATIONS_HEADER_REQUEST';
export const GET_NOTIFICATIONS_HEADER_SUCCESS = 'NOTIFICATIONS.GET_NOTIFICATIONS_HEADER_SUCCESS';
export const GET_NOTIFICATIONS_HEADER_ERROR = 'NOTIFICATIONS.GET_NOTIFICATIONS_HEADER_ERROR';
export const UPDATE_NOTIFICATIONS_REQUEST = 'NOTIFICATIONS.UPDATE_NOTIFICATIONS_REQUEST';
export const UPDATE_NOTIFICATIONS_SUCCESS = 'NOTIFICATIONS.UPDATE_NOTIFICATIONS_SUCCESS';
export const UPDATE_NOTIFICATIONS_ERROR = 'NOTIFICATIONS.UPDATE_NOTIFICATIONS_ERROR';
